import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailPage = lazy(() => import('../pages/service-detail/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const UrunlerPage = lazy(() => import('../pages/urunler/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetay = lazy(() => import('../pages/blog/components/BlogDetay'));
const KacakTespitiPage = lazy(() => import('../pages/kacak-tespiti/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hizmetlerimiz',
    element: <ServicesPage />,
  },
  {
    path: '/hizmet/:slug',
    element: <ServiceDetailPage />,
  },
  {
    path: '/projeler',
    element: <ProjectsPage />,
  },
  {
    path: '/urunlerimiz',
    element: <UrunlerPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetay />,
  },
  {
    path: '/kacak-tespiti',
    element: <KacakTespitiPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
